// extracted by mini-css-extract-plugin
module.exports = {"selectControl":"SelectAll_selectControl__3F8Ry","label":"SelectAll_label__2wkCu"};